import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { HttpClient } from '../../shared/providers/http/http-client';
import { TidyStorage } from '../../shared/providers/tidy-storage';

import { Location } from '../../shared/providers/location';
import { Cleanings } from '../cleanings/cleanings';

@Injectable()
export class OnRails {

  constructor(
    private cleanings: Cleanings,
    private httpClient: HttpClient,
    private storage: TidyStorage,
    private location: Location
  ) {}

  async getTodayCleaningsToCheckin() {
    // A Date in the URL is serialized with the device-locale timezone name, which
    // in some locales (e.g. Ukrainian) pushes it past the API's 128-byte date parse
    // limit and the timeline answers 400. See Ticket #19110.
    const today = moment().format('YYYY-MM-DD');
    const todaysCards = await this.cleanings.fetch(today, today);
    const cards = todaysCards?.[0]?.cards ?? [];
    return cards.filter(cleaningCard => cleaningCard.payment_price >= 0);
  }

  async confirmCleanings(cleaningIds: number[], cancelReasonId: number = null): Promise<any> {
    const url = `api/v1/homekeeper/confirm-jobs`;
    // Check-in must never be gated on geolocation: if GPS is denied/slow we still
    // send the confirm with best-effort (or empty) coordinates so the server records
    // confirmed_at and the Pro isn't auto-no-showed. See Trello #18064.
    let latitude = 0;
    let longitude = 0;
    try {
      const location = await this.location.get();
      latitude = location.latitude;
      longitude = location.longitude;
      if (location.error) {
        this.location.throwErrorMessage();
      }
    } catch (err) {
      this.location.throwErrorMessage();
    }
    const payload = {
      job_ids: cleaningIds,
      cancellation_reason_id: cancelReasonId,
      latitude, longitude
    };

    try {
      await this.httpClient.request({url, payload, timeout: 20000, method: 'PUT' });
    } catch (err) {
      if (err.status !== 400) {
        throw err;
      }
    }
  }

  async cleaningsPermissions(): Promise<any> {
    const url = `api/v1/homekeeper/permissions`;

    return this.httpClient.get(url);
  }

  private async hkId() {
    return await this.storage.retrieve('hk_id');
  }

  callOutAllDontFeelWell() {
    const dontFeelWellReasonId = 8;
    return this.confirmCleanings([], dontFeelWellReasonId);
  }
}
